import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/modern/isRestoring.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/app/src/components/Desktop/Desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/src/components/Mobile/Mobile.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/new-components/atoms/MuiBox/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/new-components/molecules/CommunityBrochure/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunityDetailsSpecifications"] */ "/app/src/new-components/molecules/CommunityDetailsSpecifications/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/new-components/molecules/CommunityPropertiesForSaleBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/new-components/molecules/CommunityUpcomingEvents/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/new-components/molecules/CommunityWorldClassAmenitiesBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/new-components/molecules/TestimonialsOnExperiences/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/new-components/organisms/CommunityGallery/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/new-components/organisms/UsefulResourceBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorldOfAldarCard"] */ "/app/src/new-components/organisms/WorldOfAldarCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IconMap","hasOwnProperty"] */ "/app/src/new-components/templates/SearchBox/useSearchState.tsx");
